<div mat-dialog-title>
  <h1>{{ dialogTitle$ | async }}</h1>
  <tp-modal-close-button />
</div>
@if (reauthRequired) {
  <tp-reauthenticate
    reauthAction="reset a user's password"
    [isSubmitting$]="isSubmitting$"
    (reauthStageChanged)="reauthStageChanged($event)"
  ></tp-reauthenticate>
} @else {
  <div class="tp-modal-content">
    <tp-scroll-container class="tp-modal-body" mat-dialog-content>
      <div class="tp-cluster-password-section">
        <p>
          Reset the password of a database user on '{{ data.cluster.id }}'.
          Use the pre-generated secure password below, or choose your own.
          Make sure to save the new password - it won't be shown again.
        </p>
        <tp-form-input type="text" [form]="form" field="username" label="Username" />
        <tp-form-password-input [form]="form" field="newPassword" label="New password">
          <button inputSuffix
            class="tp-cluster-password-regenerate" type="button" buttonId="regeneratePassword"
            [disabled]="isSubmitting$ | async" (click)="generatePassword(); $event.stopPropagation()"
          >
            <i class="fa-light fa-refresh"></i>
          </button>
        </tp-form-password-input>
      </div>
    </tp-scroll-container>

    <div class="tp-btn-section">
      <div class="flex-spacer"></div>
      <div class="btn-section-inner">
        <tp-button
          buttonId="resetUserPasswordModalDownloadCredentials" buttonStyle="primary-outline green stroke"
          [enabled]="!(isSubmitting$ | async) && form.valid && !credentialsDownloading"
          (click)="downloadCredentials()"
        >
          <div class="tp-download-credentials-content">
            Confirm and download credentials
          </div>
        </tp-button>
        <button type="button" [disabled]="isSubmitting$ | async" (click)="submit(false)">Confirm without downloading →</button>
      </div>
    </div>
  </div>
}
